<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      async () => {
        await $nextTick();
        await $nextTick();
        await $nextTick();
        if ($stores.services?.state?.transactionInitiation?.service?.id == 'usdt' &&
          $stores.services?.state?.transactionInitiation?.operation?.id == 'sell') {
          $refs.modal.show();
          validateSellUsdtAmount();
        }
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    hideCloseButton
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
    "
  >
    <div class="flex flex-col gap-8 relative z-2">
      <form
        class="w-full gap-4"
        v-bus:EVENTS.SERVICES.INITIATION.SUBMIT_FORM.submit.prevent
      >
        <div
          class="flex flex-col gap-5 [&_input,&_select]:text-primary [&_input,&_select]:font-bold"
        >
          <!-- Montant -->
          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 relative col-span-4">
              <label class="mb-1 px-1">Montant</label>
              <div class="relative flex items-center">
                <input
                  v-model="
                    $stores.services.state.transactionInitiation
                      .senderAmountOriginalCurrency
                  "
                  type="number"
                  class="w-full px-1"
                  required
                  @input="validateSellUsdtAmount"
                />
                <div class="absolute right-2">USDT</div>
              </div>
              <div v-if="sellUsdtError" class="text-red-600 text-xs mt-1">
                {{ sellUsdtError }}
              </div>
            </div>

            <div class="w-full flex justify-between items-center px-5">
              <div
                :class="{
                  shimmerElement:
                    $stores.services.state.transactionInitiation
                      ?.convertingAmount
                }"
              >
                {{
                  $stores.services.state.transactionInitiation
                    .senderAmountOriginalCurrency
                }}
                USDT =
                {{ $stores.services.state.transactionInitiation.senderAmount }}
                FCFA
              </div>
            </div>
          </label>
          <!-- Mode de paiement -->

          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 col-span-4" required>
              <label class="mb-1 pl-1 flex justify-between items-center">
                <span>
                  Téléphone
                  <span class="text-red-800 text-xs pointer-events-none">
                    {{
                      $stores.services.state.transactionInitiation
                        .mobileMoneyOperationConfigs.provider == 'none' &&
                      $stores.services.state.transactionInitiation.phoneOperator
                        ? $stores.services.state.transactionInitiation
                            .mobileMoneyOperationConfigs.launchErrorTitle
                        : ''
                    }}
                  </span>
                </span>
              </label>
              <div class="relative flex items-center">
                <input
                  v-model="
                    $stores.services.state.transactionInitiation.phoneNumber
                  "
                  required
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]{8,}"
                  class="w-full px-1"
                  :placeholder="`Ex: ${getPhoneExample($stores.user.state.current?.countryCode)}`"
                  ref="phoneNumberInput"
                />
                <div class="absolute right-2">
                  <PhoneDetail
                    :phoneNumber="
                      $stores.services.state.transactionInitiation.phoneNumber
                    "
                    :countryCode="$stores.user.state.current?.countryCode"
                    @loading="
                      (data) => {
                        $refs.phoneNumberInput.setCustomValidity('chargement');
                        $stores.services.state.transactionInitiation.phoneOperator =
                          '';
                      }
                    "
                    @resolved="
                      (data) => {
                        $refs.phoneNumberInput.setCustomValidity('');
                        $stores.services.state.transactionInitiation.phoneOperator =
                          data.carrier;
                      }
                    "
                    @error="
                      (data) => {
                        $stores.services.state.transactionInitiation.phoneOperator =
                          '';
                        $refs.phoneNumberInput.setCustomValidity(
                          `Erreur du numéro: ${data.error}`
                        );
                        /* data = { loading: false, error: 'invalid', data: null } */
                      }
                    "
                    v-slot="{ carrier }"
                  >
                    {{ $stores.services.state.transactionInitiation.isWave ? 'WAVE' : carrier }}
                  </PhoneDetail>
                </div>
              </div>
            </div>
          </label>

          <!-- Checkbox Wave pour la Côte d'Ivoire (CI) -->
          <div
            v-if="$stores.user.state.current?.countryCode === 'CI'"
            class="flex items-center px-5 py-3 bg-white border border-neutral-200 rounded-3xl"
          >
            <label class="flex items-center gap-3 cursor-pointer w-full select-none">
              <input
                v-model="$stores.services.state.transactionInitiation.isWave"
                type="checkbox"
                class="w-5 h-5 rounded border-neutral-300 text-primary focus:ring-primary cursor-pointer"
              />
              <span class="text-sm font-semibold text-primary">
                C'est un numéro Wave
              </span>
            </label>
          </div>

          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 col-span-4">
              <label class="mb-1 px-1"> Type d'adresse USDT </label>
              <select
                class="w-full px-1 select border-none"
                v-model="
                  $stores.services.state.transactionInitiation.usdtAddressType
                "
                required
              >
                <option
                  v-for="(option, i) in $constants.SERVICES.USDT_ADDRESS_TYPES"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
          </label>

          <label
            class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl"
          >
            <div class="flex flex-col px-4 col-span-4">
              <label class="mb-1 px-1"> Votre adresse USDT </label>
              <input
                v-model="
                  $stores.services.state.transactionInitiation.usdtAccountId
                "
                type="text"
                required
                class="w-full px-1"
                placeholder="Copier votre adresse usdt ici"
              />
            </div>
          </label>
        </div>

        <!-- Bouton résumé -->
        <div class="flex flex-col gap-4 mt-4">
          <div
            v-if="tutorialVideoUrl"
            class="underline text-right pr-2 text-red-600 font-bold text-lg flex items-center justify-end gap-2 cursor-pointer"
            @click="$bus.emit($constants.EVENTS.VIDEO.PLAY, tutorialVideoUrl)"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
              />
            </svg>
            Voir comment faire une vente
          </div>
          <div class="p-4 rounded-xl text-white bg-primary">
            <div class="text-xl font-bold">
              <span>
                <ColorImg
                  class="inline-block bg-secondary w-5 h-5 -mb-1"
                  src="/images/icons/info.svg"
                  alt=""
                />
              </span>
              Veuillez envoyez exactement le montant
              {{
                $stores.services.state.transactionInitiation
                  .senderAmountOriginalCurrency || 0
              }}
              USDT
            </div>
            <div class="text-lg mt-4">
              Sur l'adresse
              {{
                $stores.services.state.transactionInitiation?.usdtAddressType
                  ?.name
              }}
              suivant
              <div class="text-secondary font-bold flex gap-1">
                <div class="truncate">
                  {{
                    $stores.appData.state.data.addresses[
                      $stores.user.state.current?.countryCode
                    ]?.[
                      $stores.services.state.transactionInitiation
                        ?.usdtAddressType?.addressId
                    ] || 'Non dispnible pour le moment'
                  }}
                </div>
                <div
                  v-if="
                    $stores.appData.state.data.addresses[
                      $stores.user.state.current?.countryCode
                    ]?.[
                      $stores.services.state.transactionInitiation
                        ?.usdtAddressType?.addressId
                    ]
                  "
                >
                  <ColorImg
                    src="/images/icons/copy.svg"
                    class="bg-current w-6 h-6"
                  />
                </div>
              </div>
            </div>
          </div>

          <div></div>
          <ShortSummary />

          <button
            :disabled="
              $stores.services?.state?.transactionInitiationFees?.loadingFees ||
              !!sellUsdtError
            "
            :class="{
              'opacity-50':
                $stores.services?.state?.transactionInitiationFees?.loadingFees ||
                !!sellUsdtError
            }"
            class="buttonComponent w-full flex! items-center justify-center gap-2"
            type="submit"
          >
            <span> Continuer </span>
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { ref, computed } from 'vue';
import { getMinAmount, getEffectiveMaxLimit } from '@features/appData/limitsHelper';
import { resolveVideoLink } from '@features/appData/appDataHelper';
import { getPhoneExample } from '@features/shared/countries';

const { proxy } = getCurrentInstance();

const { $stores } = proxy;

const sellUsdtError = ref(null);

const minSellUsdt = computed(() => {
  const countryCode = $stores.user?.state?.current?.countryCode;
  if (!countryCode) return 0;
  return getMinAmount(countryCode, 'sell', 'usdt');
});

const maxSellUsdt = computed(() => {
  const countryCode = $stores.user?.state?.current?.countryCode;
  if (!countryCode) return Infinity;
  return getEffectiveMaxLimit(countryCode, 'sell', 'usdt');
});

const tutorialVideoUrl = computed(() =>
  resolveVideoLink($stores.appData?.state?.data, {
    serviceId: $stores.services?.state?.transactionInitiation?.service?.id,
    operation: $stores.services?.state?.transactionInitiation?.operation?.id,
    countryCode: $stores.user?.state?.current?.countryCode
  })
);

function validateSellUsdtAmount() {
  const amount = parseFloat(
    $stores.services.state.transactionInitiation
      .senderAmountOriginalCurrency
  );
  const min = minSellUsdt.value;
  const max = maxSellUsdt.value;

  if (!amount || amount < min) {
    sellUsdtError.value = `Le montant minimum de vente est de ${min} USDT`;
  } else if (max !== Infinity && amount > max) {
    sellUsdtError.value = `Le montant maximum de vente est de ${max} USDT`;
  } else {
    sellUsdtError.value = null;
  }
}

validateSellUsdtAmount();
</script>
